import React from 'react';

const Card = ({ children, className = '', title }) => {
  return (
    <div className={`
      bg-white rounded-xl shadow-sm p-6 
      border border-neutral-200
      hover:shadow-md hover:border-primary-200
      transition-all duration-200
      ${className}
    `}>
      {title && (
        <h3 className="text-xl font-semibold mb-4 text-primary-800">
          {title}
        </h3>
      )}
      {children}
    </div>
  );
};

export default Card;